import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { AssetsService } from "app/services/AssetsService";

export const StyledHeaderContainer = styled(Flex)`
    width: 100%;
    height: 300px;
    justify-content: center;
    background: url(${AssetsService.assetUrl("/images/premium-feature/header-background.png")});
    background-size: 100% 300px;
`;

export const StyledHeaderWrapper = styled(Flex)`
    justify-content: space-between;
    margin-top: 58px;
    width: 1368px;
`;

export const StyledHeaderImage = styled(Flex)`
    width: 304px;
    height: 184px;
    background: url(${AssetsService.assetUrl("/images/premium-feature/statistic-charts.png")}) center/contain no-repeat;
`;

export const StyledMainContent = styled(FlexColumn)`
    gap: 8px;
`;

export const StyledHeaderTitle = styled(Flex)`
    ${mixins.setFontVariant("h3", colorsPalettes.carbon[500])}
    font-weight: 500;
`;

export const StyledHeaderDescription = styled(Flex)`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[400])}
    line-height: 27px;
    max-width: 852px;
    margin-bottom: 20px;
`;

export const StyledHeaderButton = styled(IconButton)`
    width: fit-content !important;
`;
